import React, { useState } from "react";
import { useParams, Link } from 'react-router-dom';
import clone from "lodash.clonedeep";
import { Button, FormControl, FormGroup, Modal } from "react-bootstrap";
import { TITLE_EN, TITLE_RU } from "../../constants";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import ParticipantListItem from "./ParticipantListItem";

const DEFAULT_SELECT_VALUE = 'Выбрать из списка';

const ParticipantAdditionalInfo = (
    {
        isModalVisible,
        isRolesModalType,
        title,
        list,
        participantList,
        onAdd,
        onUpdateOrder,
        onDelete,
        onClose,
    }
) => {
    const [selectedOption, setSelectedOption] = useState('');
    const {eventPassword} = useParams();

    const handleAddToList = () => {
        onAdd(selectedOption);
        setSelectedOption(null);
    };

    const handleClose = () => {
        setSelectedOption(null);
        onClose();
    };

    function onDragEnd(result) {
        if (!result.destination) {
            return;
        }

        const reorderedListItems = reorder(
            participantList,
            result.source.index,
            result.destination.index,
        );

        onUpdateOrder(reorderedListItems);
    }

    function reorder(list, startIndex, endIndex) {
        const result = clone(list);
        const [removed] = result.splice(startIndex, 1);
        result.splice(endIndex, 0, removed);

        return result;
    }

    return (
        <Modal
            show={isModalVisible}
            onHide={handleClose}
        >
            <Modal.Header>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <FormGroup>
                    <FormControl
                        defaultValue={selectedOption ?? ''}
                        componentClass="select"
                        name="tagsList"
                        onChange={(e) => setSelectedOption(e.target.value)}
                    >
                        <option value="">{DEFAULT_SELECT_VALUE}</option>
                        {list?.map((item) => (
                            <option
                                key={item.id}
                                value={item.id}
                            >
                                {item[TITLE_RU] ?? item[TITLE_EN]}
                            </option>
                        ))}
                    </FormControl>
                </FormGroup>
                {!isRolesModalType && (
                    <p>
                        <i>
                            Добавить новый тег и отредактировать существующие можно <br />
                            в разделе <Link to={`/event/${eventPassword}/episodes`}>Редактор эпизодов</Link> при редактировании эпизода
                            во вкладке <strong>"Теги"</strong>
                        </i>
                    </p>
                )}
                <FormGroup>
                    <Button
                        disabled={!selectedOption}
                        onClick={handleAddToList}
                    >
                        Добавить
                    </Button>
                </FormGroup>
                <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId="droppable">
                        {(provided) => (
                            <div
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                            >
                                {participantList?.map((item, index) => (
                                    <Draggable
                                        key={item.id}
                                        draggableId={`${item.id || index}`}
                                        index={index}
                                    >
                                        {(provided) => (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                                style={
                                                    provided.draggableProps.style
                                                }
                                            >
                                                <ParticipantListItem
                                                    item={item}
                                                    onDelete={onDelete}
                                                />
                                            </div>
                                        )}
                                    </Draggable>
                                ))}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </DragDropContext>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={handleClose}>
                    Закрыть
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ParticipantAdditionalInfo;
